export { AllIntersectionResolvePipe } from './all-intersection-resolve.pipe';
